import { TApiResponse, TLoginResponse, TUser } from "@/types";
import { TLoginSchema, TResetPasswordSchema } from "@/features/auth/forms/schema";

import http from "@/http";

export type TChangePasswordInput = {
    username: string
    password: string
    otp: string
}

export async function getUser() {
    const response = await http.get<TApiResponse<TUser>>("/users-info")
    return response.data
}

export async function login(input: TLoginSchema) {
    const response = await http.post<TApiResponse<TLoginResponse>>(
        "/auth/login", input
    )
    return response.data
}

export async function register(input: FormData) {
    const response = await http.post<TApiResponse<null>>(
        "/auth/register", input, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    )
    return response.data
}

export async function forgotPassword(email: string) {
    const response = await http.post<TApiResponse<null>>(
        "/users/forgot-password", {"username": email}
    )
    return response.data
}

export async function resetPassword(input: TResetPasswordSchema) {
    const response = await http.post<TApiResponse<null>>(
        "/users/reset-password", {
            username: input.username,
            password: input.password,
            otp: input.otp
        }
    )
    return response.data
}

export async function resendOtp(email: string) {
    const response = await http.post<TApiResponse<null>>(
        "/users/resend?context=reset", {"username": email}
    )
    return response.data
}

/**
 * ZCT only changes a password against a one-time code: `UserServiceImplementor#updatePassword`
 * looks the account up by `username` and rejects the request unless `otp` matches an unused
 * `VerificationToken` for it. The code is requested with `forgotPassword` above.
 */
export async function changePassword(input: TChangePasswordInput) {
    const response = await http.post<TApiResponse<null>>(
        "/users/update-password", input
    )
    return response.data
}

export async function verifyEmail(email: string) {
    const response = await http.post<TApiResponse<null>>(
        `/auth/verify/${email}`
    )
    return response.data
}

/**
 * `PUT /api/v1/clients/{id}` rather than `/users/{id}`: both reach the same
 * `UserService#updateUser`, but only the client route is declared
 * `consumes = MULTIPART_FORM_DATA_VALUE` with `@ModelAttribute`. The users route takes a JSON
 * `@RequestBody`, so the multipart body this sends was answered with 415 there.
 */
export async function update_user(input: FormData, id: string) {
    const response = await http.put<TApiResponse<TUser>>(
        `/clients/${id}`, input, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    )
    return response.data
}